module.exports = __webpack_public_path__ + "5.0.2/img/vcu_nxp.30731585.png";